import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Tag } from 'primereact/tag';
import { Tooltip } from 'primereact/tooltip';
import { Toolbar } from 'primereact/toolbar';
import React, { useRef, useState } from 'react';
import { formatarData } from '../../service/controller';
import UserState from './Context/state';
import ModalCreateUser from './ModalCreateUser';
import ModalEditUser from './ModalEditUser';
import AwsImage from '../../components/AwsImage';

const UsersScreens = () => {

    const { users, createDialog, setCreateDialog, userDialog, setUserDialog } = UserState()

    const [user, setUser] = useState()
    const [globalFilter, setGlobalFilter] = useState(null);
    const dt = useRef(null);


    const openNew = () => {
        // setProduct(emptyProduct);
        setCreateDialog(true);
    };


    const editProduct = (user) => {
        setUser({ ...user });
        setUserDialog(true);
    };







    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="Novo" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const codeBodyTemplate = (rowData) => {
        return (
            <>
                <span className="p-column-title">Code</span>
                {rowData.id}
            </>
        );
    };

    const nameBodyTemplate = (rowData) => {
        return (
            <>
                <span className="p-column-title">Name</span>
                {rowData.name}
            </>
        );
    };

    const imageBodyTemplate = (rowData) => {
        return (
            <>
                <span className="p-column-title">Image</span>
                <AwsImage
                    awsId={rowData.aws_fk ?? rowData.aws?.id}
                    aws={rowData.aws}
                    alt={rowData.name}
                    className="shadow-2"
                    usage="avatar"
                    width={60}
                    height={60}
                    style={{ width: "60px", height: "60px", objectFit: "cover", borderRadius: "8px" }}
                />
            </>
        );
    };

    const EmailBodyTemplate = (rowData) => {
        return (
            <>
                <span className="p-column-title">Email</span>
                {rowData.email}
            </>
        );
    };

    const categoryBodyTemplate = (rowData) => {
        return (
            <>
                <span className="p-column-title">Planos</span>
                {rowData?.plan?.name}
            </>
        );
    };

    const roleBodyTemplate = (rowData) => {
        return (
            <>
                <span className="p-column-title">Role</span>
                {rowData.role}
            </>
        );
    };

    const createdBodyTemplate = (rowData) => {
        return (
            <>
                <span className="p-column-title">Criado</span>
                {formatarData(rowData.createdAt)}
            </>
        );
    };

    const AI_CREDIT_COLORS = {
        text:    { severity: 'secondary', icon: 'pi-align-left' },
        image:   { severity: 'info',      icon: 'pi-image' },
        stream:  { severity: 'success',   icon: 'pi-video' },
        archive: { severity: 'warning',   icon: 'pi-folder' },
    };

    const aiCreditsBodyTemplate = (rowData) => {
        const credits = rowData?.aiCredits;
        const entries = credits ? Object.entries(credits) : [];

        if (entries.length === 0) {
            return <span style={{ color: '#BFC2C6', fontSize: '0.8rem' }}>—</span>;
        }

        return (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem', justifyContent: 'center' }}>
                {entries.map(([operation, value]) => {
                    const config = AI_CREDIT_COLORS[operation] || { severity: 'warning', icon: 'pi-bolt' };
                    return (
                        <Tag
                            key={operation}
                            severity={config.severity}
                            style={{ fontSize: '0.75rem', padding: '0.25rem 0.5rem' }}
                        >
                            <i className={`pi ${config.icon}`} style={{ marginRight: '0.3rem', fontSize: '0.75rem' }}></i>
                            <span style={{ textTransform: 'capitalize' }}>{operation}</span>
                            <span style={{ marginLeft: '0.35rem', fontWeight: 700 }}>{value}</span>
                        </Tag>
                    );
                })}
            </div>
        );
    };

    const countBodyTemplate = (rowData) => {
        const count = rowData?._count;
        const id = `count-${rowData.id}`;
        return (
            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                <Tooltip target={`.zona-${id}`} content="Zonas" position="top" />
                <span className={`zona-${id}`} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', fontSize: '0.82rem', color: '#6c757d', cursor: 'default' }}>
                    <i className="pi pi-th-large" style={{ fontSize: '0.85rem' }}></i> {count?.zoneUser ?? 0}
                </span>

                <Tooltip target={`.subzona-${id}`} content="Subzonas" position="top" />
                <span className={`subzona-${id}`} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', fontSize: '0.82rem', color: '#6c757d', cursor: 'default' }}>
                    <i className="pi pi-sitemap" style={{ fontSize: '0.85rem' }}></i> {count?.subZoneUsers ?? 0}
                </span>

                <Tooltip target={`.canal-${id}`} content="Canais" position="top" />
                <span className={`canal-${id}`} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', fontSize: '0.82rem', color: '#6c757d', cursor: 'default' }}>
                    <i className="pi pi-video" style={{ fontSize: '0.85rem' }}></i> {count?.channels ?? 0}
                </span>
            </div>
        );
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editProduct(rowData)} />
                {/* <Button icon="pi pi-trash" className="p-button-rounded p-button-warning mt-2" onClick={() => confirmDeleteProduct(rowData)} /> */}
            </div>
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Gerenciamento de usuários</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
            </span>
        </div>
    );




    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <Toolbar className="mb-4" left={leftToolbarTemplate}></Toolbar>
                    <DataTable
                        ref={dt}
                        value={users}
                        dataKey="id"
                        paginator
                        rows={10}
                        rowsPerPageOptions={[5, 10, 25]}
                        className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} products"
                        globalFilter={globalFilter}
                        emptyMessage="No products found."
                        header={header}
                        responsiveLayout="scroll"
                    >
                        <Column field="id" align={"center"} header="Code" sortable body={codeBodyTemplate} headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column header="Image" align={"center"} body={imageBodyTemplate} headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="name" align={"center"} header="Name" sortable body={nameBodyTemplate} headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="email" align={"center"} header="E-mail" body={EmailBodyTemplate} sortable headerStyle={{ width: '14%', minWidth: '8rem' }}></Column>
                        <Column field="category" align={"center"} header="Plano" sortable body={categoryBodyTemplate} headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="role" align={"center"} header="Role" sortable body={roleBodyTemplate} headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="role" align={"center"} header="Criado" sortable body={createdBodyTemplate} headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column align={"center"} header="Uso" body={countBodyTemplate} headerStyle={{ minWidth: '9rem' }}></Column>
                        <Column align={"center"} header="Créditos IA (Últimos 30 dias)" body={aiCreditsBodyTemplate} headerStyle={{ minWidth: '12rem' }}></Column>

                        <Column align={"center"} body={actionBodyTemplate}></Column>
                    </DataTable>

                    {userDialog ? <ModalEditUser user={user} userDialog={userDialog} hideDialog={() => setUserDialog(false)} />
                        : null}
                    <ModalCreateUser createDialog={createDialog} hideDialog={() => setCreateDialog(false)} />
                    {/* <Dialog visible={deleteProductDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteProductDialogFooter} onHide={hideDeleteProductDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {user? && (
                                <span>
                                    Are you sure you want to delete <b>{product.name}</b>?
                                </span>
                            )}
                        </div>
                    </Dialog>

                    <Dialog visible={deleteProductsDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteProductsDialogFooter} onHide={hideDeleteProductsDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {product && <span>Are you sure you want to delete the selected products?</span>}
                        </div>
                    </Dialog> */}
                </div>
            </div>
        </div>
    );
};

export default UsersScreens;
